module.exports = __webpack_public_path__ + "static/assets/f0c2680b81e1da7ea84a8111acf89173.svg";